import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { Field } from 'redux-form';

import AutosuggestField from 'components/fields/AutosuggestField';

import { requestSearchUsers } from 'redux/modules/users';
import { accountLoginFail } from 'redux/modules/account';

const OrdersTableRowItemDriver = ({
  namePrefix,
  disabled,
  change,
  className,
  actions,
}) => (
  <Field
    className={className}
    id={`${namePrefix}.Driver Name`}
    name={`${namePrefix}.Driver Name`}
    component={AutosuggestField}
    placeholder="-Select Driver-"
    fullWidth
    listWidth="auto"
    size="sm"
    color="light"
    disabled={disabled}
    renderSuggestionContent={suggestion => (
      `${suggestion['First Name']} ${suggestion['Last Name']}`
    )}
    renderInputContent={suggestion => (
      `${suggestion['First Name']} ${suggestion['Last Name']}`
    )}
    onSuggestionSelected={(suggestion) => {
      change(`${namePrefix}.Selected Driver Name`, `${suggestion['First Name']} ${suggestion['Last Name']}`);
      change(`${namePrefix}.Driver ID`, suggestion.ID);
      return `${suggestion['First Name']} ${suggestion['Last Name']}`;
    }}
    fetchSuggestions={({ value, limit, offset }) => (
      value.length > 0
        ? requestSearchUsers({
          filters: [
            {
              name: 'Role',
              operation: 'eq',
              val: 'Driver',
            },
            {
              name: 'Active',
              operation: 'eq',
              val: 'true',
            },
            {
              name: 'Full Name',
              operation: 'startswith',
              val: value,
              case_sensitivity: false,
            },
          ],
          limit,
          offset,
        }).then(res => res.data,
          (err) => {
            if (err.data.error === 'Need authorisation') {
              actions.accountLoginFail();
            }
            return err;
          })
        : requestSearchUsers({
          filters: [
            {
              name: 'Role',
              operation: 'eq',
              val: 'Driver',
            },
            {
              name: 'Active',
              operation: 'eq',
              val: 'true',
            },
          ],
          limit,
          offset,
        }).then(res => res.data,
          (err) => {
            if (err.data.error === 'Need authorisation') {
              actions.accountLoginFail();
            }
            return err;
          })
    )}
    onlyConfirmedSelection
  />
);

OrdersTableRowItemDriver.propTypes = {
  namePrefix: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  change: PropTypes.func.isRequired,
  className: PropTypes.string,
  actions: PropTypes.shape({
    accountLoginFail: PropTypes.func.isRequired,
  }).isRequired,
};

OrdersTableRowItemDriver.defaultProps = {
  className: '',
  disabled: false,
};

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({ accountLoginFail }, dispatch),
});

export default connect(null, mapDispatchToProps)(
  OrdersTableRowItemDriver,
);



// WEBPACK FOOTER //
// ./src/components/workflow/OrdersTable/OrdersTableRowItemDriver.js